import { GetCart, GetCartInfo } from "./cart/components/cart";
import { GoogleUaEvent } from "./dataLayerServices/googleUaEvent";
import { DataLayerService } from "./dataLayerServices/dataLayerService";
import ShowBasket from "./cart/components/showBasket";
import HideBasket from "./cart/components/hideBasket";

export default function presentkortJs() {
  $(function () {
    if ($("#twocolumns.presentkort-page").length == 0) {
      return;
    }

    $(".voucherDate").datepicker({
      onSelect: function (date) {
        const selectedDate = new Date(Date.parse(date));
        buildSelectorTimeStepsOptionsList($("#m_emaildeliveryTime"), selectedDate, 30);
      },
    });

    $(".voucherDate").datepicker($.datepicker.regional["sv"]);
    $(".voucherDate").datepicker("option", "dateFormat", "yy-mm-dd");
    $(".voucherDate").datepicker("option", "defaultDate", "now");
    $(".voucherDate").datepicker("option", "minDate", "now");
    $(".voucherDate").datepicker("setDate", Date.now());

    buildSelectorTimeStepsOptionsList($("#m_emaildeliveryTime"), new Date(), 30);

    var step1 = $(".presentkort-page #step1");
    var step2 = $(".presentkort-page #step2");
    var step3 = $(".presentkort-page #step3");

    var btnNext = $(".presentkort-page .btn-fortsatt");
    var btnPrev = $(".presentkort-page .btn-tillbaka");
    var btnBuy = $(".presentkort-page .btn-kop");
    var voucherError = $(".presentkort-page .voucherError");
    var voucherAdded = $(".presentkort-page .voucherAdded");
    var amount = $(".presentkort-page .voucherAmount");
    $(document).on('click', ".presentkort-page .btn-fortsatt", function (e) {
      var selectedType = $(".select-type input:checked").val();
      var selectedDiv = $(".presentkort-page #step3 #present" + selectedType);
      voucherError.hide();
      voucherAdded.hide();
      if (selectedType) {
        voucherError.hide();
        if (step1.is(":visible")) {
          step1.hide();
          if (selectedType != "Company") {
            step2.show();
          }
          else {
            step3.show();
            selectedDiv.show();
            btnNext.hide();
            btnBuy.show();
          }
          btnPrev.show();
          return;
        }
        if (step2.is(":visible")) {

          $.ajax({
            type: "POST",
            url: "/api/Voucher/CheckAmount",
            data: JSON.stringify(amount.val() ? amount.val() : "0"),
            contentType: "application/json",
            success: function (data) {
              if (data.Message) {
                voucherError.show();
                voucherError.html(data.Message);
              }
              else {
                step3.show();
                selectedDiv.show();
                step2.hide();
                btnNext.hide();
                btnBuy.show();
              }
            }
          });
          return;
        }
      }
    });

    $(document).on('click', ".presentkort-page .btn-tillbaka", function (e) {
      var selectedType = $(".select-type input:checked").val();
      var selectedDiv = $(".presentkort-page #step3 #present" + selectedType);
      btnNext.show();
      btnBuy.hide();
      voucherError.hide();
      voucherAdded.hide();
      selectedDiv.find(".voucherCompanyError").hide();
      if (step2.is(":visible")) {
        btnPrev.hide();
        step2.hide();
        step1.show();
        amount.val("");
        return;
      }
      if (step3.is(":visible")) {
        step3.hide();
        selectedDiv.hide();
        if (selectedType != "Company") {
          step2.show();
        }
        else {
          btnPrev.hide();
          step1.show();
        }
        return;
      }
    });
    $(document).on('click', ".presentkort-page input[name='rbYesNo']", function (e) {
      if ($(this).val() == "rbYes") {
        $(".presentkort-page #presentCompany .invoiceField").hide();
      }
      else {
        $(".presentkort-page #presentCompany .invoiceField").show();
      }
    });
    $(document).on('click', ".presentkort-page .btn-kop", function (e) {
      var selectedType = $(".select-type input:checked").val();
      var selectedDiv = $(".presentkort-page #step3 #present" + selectedType);
      var object = {};
      voucherError.hide();
      voucherAdded.hide();

      object.Type = selectedType;
      object.SelectedDate = selectedDiv.find(".voucherDate:visible").val();;
      object.SelectedTime = selectedDiv.find(".voucherTime:visible").val();
      object.Email = selectedDiv.find("#m_emailAddress").val();
      object.EmailRepeat = selectedDiv.find("#m_repeatEMailAddress").val();
      object.VoucherMessage = selectedDiv.find(".voucherMessage").val();;
      object.Price = amount.val();
      object.SMSNumber = selectedDiv.find("#m_voucherSMSNumber").val();
      object.ShippingName = selectedDiv.find("#m_shippingName").val();
      object.ShippingStreet = selectedDiv.find("#m_shippingStreet").val();
      object.ShippingCity = selectedDiv.find("#m_shippingCity").val();
      object.ShippingZip = selectedDiv.find("#m_shippingPostalCode").val();

      $.ajax({
        type: "POST",
        url: "/api/Voucher",
        data: JSON.stringify(object),
        contentType: "application/json",
        error: function (jqXHR, textStatus, errorThrown) {
          if (jqXHR.responseJSON.Message && !jqXHR.responseJSON.IsSuccess) {
            voucherError.show();
            voucherError.html(jqXHR.responseJSON.Message);
          }
        },
        success: function (data) {
          if (data.Message && !data.IsSuccess) {
            voucherError.show();
            voucherError.html(data.Message);
          }
          else if (data.Message && data.IsSuccess) {
            voucherAdded.show();
            voucherAdded.html(data.Message);
            GetCart(true,
              function () {
                let googleUaEvent = new GoogleUaEvent('CustomerActionEvent');
                googleUaEvent.setPayload('kopknapp', 'Lagg i varukorgen', 'Presentkort', parseInt(amount.val()));
                const dataLayerService = new DataLayerService();
                dataLayerService.triggerUaEvent(googleUaEvent);
              });
            GetCartInfo();
            ShowBasket();
            setTimeout(HideBasket, 2000);
            selectedDiv.find("#m_emailAddress").val("");
            selectedDiv.find("#m_repeatEMailAddress").val("");
            selectedDiv.find(".voucherMessage").val("");
            selectedDiv.find("#m_voucherSMSNumber").val("");
            selectedDiv.find("#m_shippingName").val("");
            selectedDiv.find("#m_shippingStreet").val("");
            selectedDiv.find("#m_shippingCity").val("");
            selectedDiv.find("#m_shippingPostalCode").val("");
            selectedDiv.find(".voucherDate:visible").val("");
            selectedDiv.find(".voucherTime:visible").val("");
          }
        }
      });
    });

    function buildSelectorTimeStepsOptionsList(timeSelectorJqElement, date, stepInMinutes) {
      let startTime = new Date(0, 0, 0, 0, 0);
      timeSelectorJqElement.empty();

      if (isToday(date)) {
        startTime = new Date();
        // No time for "Omgående": the browser's clock may be in another time zone,
        // so the server sends it by its own clock
        timeSelectorJqElement.append(new Option("Omgående", "", true, true))
        dateAddMinutes(startTime, stepInMinutes - (startTime.getMinutes() % stepInMinutes))
      }

      const timeItemsSet = getTimeItemsSet(stepInMinutes, startTime);
      timeItemsSet.forEach(timeItem => {
        timeSelectorJqElement.append(new Option(timeItem, timeItem))
      })
    }

    function getTimeItemsSet(
      stepMinutes = 1,
      fromTime = new Date(0, 0, 0, 0, 0),
      toTime = new Date(0, 0, 0, 23, 59)
    ) {

      const itemsSet = [];

      const fromMinutes = fromTime.getHours() * 60 + fromTime.getMinutes();
      const toMinutes = toTime.getHours() * 60 + toTime.getMinutes();

      for (let i = fromMinutes; i <= toMinutes; i += stepMinutes) {
        const hours = Math.trunc(i / 60);
        let minutes = ((i / 60 - hours) * 60).toFixed(0);
        if (minutes.length === 1) {
          minutes = "0" + minutes;
        }

        itemsSet.push(hours + ":" + minutes)
      }

      return itemsSet;
    }

    function dateAddMinutes(date, addedMinutesNumber) {
      date.setTime(date.getTime() + addedMinutesNumber * 60 * 1000)
    }

    function isToday(date) {
      const now = new Date();
      return date != null &&
        now.getFullYear() === date.getFullYear() &&
        now.getMonth() === date.getMonth() &&
        now.getDate() === date.getDate();
    }
  });
}